<template>
<div style="width: 100%">

  <div class="input-space container align-items-center" v-if="!size">
    <div v-if="icon" class="icons">
      <i :class="'fa fa-' + icon" aria-hidden="true"></i>
    </div>
    <input :type="type" :placeholder="placeholder" :name="name" :value="value" class="input">
  </div>

  <div class="input-space container align-items-center" v-if="size === 'big'">
    <div v-if="icon" class="icons">
      <i :class="'fa fa-' + icon" aria-hidden="true"></i>
    </div>
    <input :type="type" :placeholder="placeholder" :name="name" :value="value" class="input input-big">
  </div>

  <div class="input-space container align-items-center" v-if="size === 'small'">
    <div v-if="icon" class="icons">
      <i :class="'fa fa-' + icon" aria-hidden="true"></i>
    </div>
    <input :type="type" :placeholder="placeholder" :name="name" :value="value" class="input input-small">
  </div>

  <div class="input-space input-space-special container align-items-center" v-if="size === 'special'" :style="{background: background, color: color}">
    <div v-if="icon" class="icons">
      <i :class="'fa fa-' + icon" aria-hidden="true"></i>
    </div>
    <input :style="{color: color}" :type="type" :placeholder="placeholder" :name="name" :value="value" class="input input-big">
  </div>

</div>
</template>

<script>
export default {
  name: 'buttonComponent',
  data () {
    return {}
  },
  props: {
    size: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: 'Digite seu texto'
    },
    name: {
      type: String
    },
    value: {
      type: String
    },
    icon: {
      type: String
    },
    background: {
      type: String
    },
    color: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.icons {
    margin-right: 10px;
    opacity: 0.5;
}
.btn-space {
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/input/index.vue